"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _InternalPageHeader = _interopRequireDefault(require("web/shared/components/InternalPageHeader"));
var _QueryBoundary = _interopRequireDefault(require("web/shared/relay/QueryBoundary"));
var _JobsFrameStyles = require("web/shared/jobs/JobsFrame.styles.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _consolePage = require("web/shared/console/consolePage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The chrome every jobs view renders inside: the full-bleed page column, the
* view-switching nav, the heading, and the loading / failure lines.
*
* Every view here reads on render and suspends, so the frame holds the view's
* content inside a boundary and says the two things a reader sees while
* waiting or after a failure. A view that said them itself would be a second
* wording of the same two states, in six places.
*
* The shared jobs views use react-router directly (every product mounts them
* inside its own RouterProvider, and every view lives at the same path in
* every product), so a product page is just "gate, then mount" with no
* navigation wiring of its own.
*
* This belongs to the jobs console and nothing else: chrome shared between
* unrelated consoles becomes a thing neither owns and both are afraid to
* change.
*/ // The jobs console's views, in the order the nav shows them. The paths are the
// same in every product, which is what lets this be shared at all.
const NAV_ITEMS = [{
  to: "/internal/jobs",
  label: "jobs"
}, {
  to: "/internal/jobs/dispatches",
  label: "dispatches"
}, {
  to: "/internal/jobs/schedule",
  label: "schedule"
}];
function JobsFrame(props) {
  var _props$context;
  const title = props.title,
    intro = props.intro,
    activePath = props.activePath,
    onRefresh = props.onRefresh;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_consolePage.consolePage.inset, _consolePage.consolePage.roomBelow, _JobsFrameStyles.styles.page)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("nav", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_JobsFrameStyles.styles.nav)), {}, {
      children: NAV_ITEMS.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
        to: item.to
      }, stylex.props(_JobsFrameStyles.styles.navLink, item.to === activePath && _JobsFrameStyles.styles.navLinkActive)), {}, {
        children: item.label
      }), item.to))
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_JobsFrameStyles.styles.section)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InternalPageHeader.default, {
        title: title,
        context: (_props$context = props.context) !== null && _props$context !== void 0 ? _props$context : null,
        backTo: props.backTo,
        backLabel: props.backLabel,
        trailing: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          onClick: onRefresh
        }, stylex.props(_JobsFrameStyles.styles.button)), {}, {
          children: "Refresh"
        }))
      }), intro != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_JobsFrameStyles.styles.intro)), {}, {
        children: intro
      })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_QueryBoundary.default, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
          children: "Loading\u2026"
        })),
        renderError: message => /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.errorText)), {}, {
          children: message
        })),
        resetKey: props.resetKey,
        children: props.children
      })]
    }))]
  }));
}
var _default = exports.default = JobsFrame;